module.exports = __webpack_public_path__ + "img/CRT_Spear-001.b5b8e4a5.png";